export const MOBILE = 1200;
export const MOBILE__MQ = `screen and (max-width: ${MOBILE}px)`;
